import { useRef, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  LinearProgress,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Security as InsuranceIcon } from "@mui/icons-material";
import ProfileStepperForm from "./ProfileStepperForm";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router";
import FormApi from "./api/formApi";
import LeadPrompt from "./components/LeadPrompt";
import RegisterMobile from "./components/RegisterMobile";
import ThankYou from "./components/ThankYou";
import CompletedNotice from "./components/CompletedNotice";

const ProfilingForm = () => {
  const formikRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const [saveLoading, setSaveLoading] = useState(false);
  const [genratingFormLoading, setGenratingFormLoading] = useState(false);
  const [showStepper, setShowStepper] = useState(false);
  const [formId, setFormId] = useState(null);
  const [showLeadPrompt, setShowLeadPrompt] = useState(false);
  const [leadInfo, setLeadInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [createLeadLoading, setCreateLeadLoading] = useState(false);
  const [registredData, setRegistredData] = useState({ mobile: "", email: "" });
  const [FilledData, setFilledData] = useState({});
  const [showThankYou, setShowThankYou] = useState(false);
  const filledPercent = FilledData?.profilingformStatus?.savePercentage ?? 0;
  const isCompleted = FilledData?.profilingformStatus?.isCompleted;
  const isSaved = FilledData?.profilingformStatus?.isSaved;

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // Warn user before page refresh if stepper is active and form has unsaved data
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (showStepper && !isCompleted && !showThankYou) {
        event.preventDefault();
        event.returnValue =
          "Your form data will be lost if you leave this page. Please save before refreshing.";
        return event.returnValue;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      if (!showThankYou) {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      }
    };
  }, [showStepper, isCompleted, showThankYou]);

  async function requestProfilingFormDetails(data) {
    try {
      const responce = await FormApi.userEmailAndModbileCheckExistance(data);
      // console.log("responce", responce);

      setFilledData(responce);
      setFormId(responce?._id);
    } catch {
      setShowLeadPrompt(true);
      setShowStepper(false);
      setFilledData({});
      return;
    }
  }

  async function createLead(data) {
    try {
      setCreateLeadLoading(true);
      const response = await FormApi.createLead(data);
      setCreateLeadLoading(false);
      return response;
    } catch (error) {
      setCreateLeadLoading(false);
      console.error("Error creating lead:", error);
      throw error;
    }
  }

  return (
    <div className="card mb-0 ">
      <div
        className=" p-0 d-flex flex-column border-1 border-secondary"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "rgb(255, 255, 255)",
        }}
      >
        {/* Header Section */}
        <Card
          sx={{
            background: "linear-gradient(90deg, #064a9cff 0%, #1e88e5 100%)",
            color: "#fff",
            // borderRadius: 3,
            // boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
            overflow: "hidden",
            paddingX: { xs: 2, sm: 3 },
            // paddingY: { xs: 2, sm: 1.5 },
          }}
        >
          <CardContent
            sx={{
              // display: "flex",
              // // justifyContent: "space-between",
              // alignItems: "center",
              // margin auto mui
              margin: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: isSmallScreen ? 1 : 2,

                // background: "#fff",
              }}
            >
              {/* Left section */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    borderRadius: "50%",
                    // p: 0.4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <InsuranceIcon sx={{ fontSize: 25, color: "#fff" }} />
                </Box>
                <Box>
                  <Typography
                    variant={isSmallScreen ? "subtitle2" : "h5"}
                    sx={{
                      fontWeight: "bold",
                      // lineHeight: 1.2,
                      letterSpacing: "0.5px",
                      color: "#fff",
                    }}
                  >
                    Financial Planning Profiling Form
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "rgba(255,255,255,0.85)",
                      fontSize: "0.9rem",
                    }}
                  >
                    Complete your financial details below
                  </Typography>
                </Box>
              </Box>

              {/* Right section */}
              {showStepper && !showThankYou && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    minWidth: isSmallScreen ? "100%" : 220,
                    justifyContent: isSmallScreen ? "center" : "flex-end",
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="body2"
                      sx={{ color: "white", mb: 0.3, fontWeight: 500 }}
                    >
                      Filled: {filledPercent}%
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={filledPercent}
                      sx={{
                        height: 6,
                        borderRadius: 3,
                        backgroundColor: "rgba(255,255,255,0.25)",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#0bd626",
                        },
                      }}
                    />
                  </Box>

                  <Button
                    variant="contained"
                    size="small"
                    disabled={saveLoading || isCompleted}
                    sx={{
                      fontWeight: "bold",
                      textTransform: "none",
                      px: 3,
                      py: 0.8,
                      borderRadius: 2,
                      backgroundColor: isSaved
                        ? "#43a047"
                        : "rgba(255,255,255,0.15)",
                      color: "#fff",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: isSaved
                          ? "#388e3c"
                          : "rgba(255,255,255,0.25)",
                      },
                    }}
                    onClick={async () => {
                      try {
                        setSaveLoading(true);
                        const values =
                          formikRef.current?.values || FilledData || {};
                        const percent = filledPercent;
                        const payload = {
                          ...values,
                          profilingformStatus: {
                            isSaved: true,
                            isCompleted: isCompleted ?? false,
                            savePercentage: percent,
                            formStepsCompleted:
                              FilledData?.profilingformStatus
                                ?.formStepsCompleted ?? 0,
                          },
                        };
                        console.log("Saving form with payload:", formId);
                        const resp = await FormApi.submitProfilingFormData(
                          payload,
                          formId,
                        );
                        setFilledData(resp || payload);
                        toast.success("Form saved successfully");
                      } catch (err) {
                        console.error(err);
                        toast.error("Failed to save form");
                      } finally {
                        setSaveLoading(false);
                      }
                    }}
                  >
                    {saveLoading
                      ? "Saving..."
                      : isSaved
                        ? "Save"
                        : isCompleted
                          ? "Completed"
                          : "Save"}
                  </Button>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      </div>
      <div className="card-body p-0">
        {showThankYou || FilledData?.profilingformStatus?.savedNow ? (
          <ThankYou />
        ) : !showStepper ? (
          <RegisterMobile
            initialValue={registredData}
            loading={genratingFormLoading}
            onSubmit={async (data) => {
              setRegistredData(data);
              await requestProfilingFormDetails(data);
              setShowStepper(true);
            }}
          />
        ) : FilledData?.profilingformStatus?.isCompleted === true &&
          FilledData?.profilingformStatus?.savedNow != true ? (
          <CompletedNotice />
        ) : (
          <ProfileStepperForm
            formId={formId}
            formikRef={formikRef}
            perFilledData={registredData}
            FilledData={FilledData}
            profilingformStatus={FilledData?.profilingformStatus}
            onStatusChange={(status) => {
              setFilledData((prev) => ({
                ...(prev || {}),
                profilingformStatus: {
                  ...((prev && prev.profilingformStatus) || {}),
                  ...status,
                },
              }));
            }}
            onSave={(resp) => {
              console.log("form saved with response", resp);
              // update FilledData with response from save if provided
              // if (resp) setFilledData(resp);
            }}
            onFormValuesChange={(values) => {
              // persist form values to FilledData so they survive navigation
              setFilledData((prev) => ({
                ...prev,
                ...values,
              }));
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ProfilingForm;
